import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import "./styles/app.scss";
import "./styles/colors.scss";
import "./styles/Home.scss";
import "./styles/Terms.scss";
import BookDemo from "./components/BookDemo";
import Terms from "./components/Terms";

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/demo" element={<BookDemo />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </Router>
  );
}

export default App;
